<template>
	<div style="width: 100%; padding: 4px">
		<b-row>
			<b-col cols="4" class="text-left">
				<div class="sa-ft-badge-v2 p-1 mt-2" v-if="!!documentoJsonData.primaryKey"
					:style="{ marginLeft: '25px', color: getClassBadge('color', documentoJsonData.documentoStato), border: getClassBadge('border', documentoJsonData.documentoStato) }">
					{{ documentoJsonData.documentoStato }}
					<span>{{ getEmojiDocumentoStato(documentoJsonData.documentoStato) }}</span>
				</div>
			</b-col>
			<b-col cols="4" class="text-center">
				<div class="text-center mb-2 justify-content-center">
					<b-button size="sm" variant="light" @click="showCards = !showCards"
						class="border shadow-sm px-4 pill">
						<b-icon :icon="showCards ? 'chevron-up' : 'chevron-down'"></b-icon>
						{{ showCards ? "Nascondi Dettaglio" : "Mostra Dettaglio" }}
						<b-badge v-if="!isCompiled" style="letter-spacing: 1px;" variant="warning" class="ml-2">DATI
							INCOMPLETI</b-badge>
						<b-badge v-else style="letter-spacing: 1px;" variant="success" class="ml-2">STRUTTURA:
							<b class="ml-1" style="letter-spacing: 1px;"> {{
								documentoJsonData.strutturaDenominazione.toUpperCase() }}</b>
						</b-badge>
					</b-button>
				</div>
			</b-col>
		</b-row>

		<b-collapse v-model="showCards" class="mb-4">
			<div class="ft-section-container" style="padding: 10px;">
				<div class="ft-section-wrapper-item">
					<div class="sa-contabilita-info-card">
						<div class="sa-contabilita-card-header">
							🏢 Struttura Mittente
							<b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right"
								:disabled="true">
								<i class="fas fa-pencil-alt"></i>
							</b-button>
						</div>
						<div class="sa-contabilita-card-grid">
							<span class="sa-contabilita-label">🏢 Denominazione:</span>
							<span class="sa-contabilita-data">{{ documentoJsonData.strutturaDenominazione }} ({{
								documentoJsonData.strutturaCodice }})</span>

							<span class="sa-contabilita-label">🆔 P.IVA:</span>
							<span class="sa-contabilita-data">{{ documentoJsonData.strutturaPartitaIva }}</span>

							<span class="sa-contabilita-label">📞 Tel:</span>
							<span class="sa-contabilita-data">{{ documentoJsonData.strutturaTelefono }}</span>

							<span class="sa-contabilita-label">📧 Email:</span>
							<span class="sa-contabilita-data">{{ documentoJsonData.strutturaEmail }}</span>

							<span class="sa-contabilita-label">🏦 IBAN:</span>
							<span class="sa-contabilita-data">{{ documentoJsonData.strutturaIban }} ({{
								getInfoStrutturaIban()
							}})</span>
						</div>
					</div>
				</div>

				<div class="ft-section-wrapper-item">
					<div class="sa-contabilita-info-card">
						<div class="sa-contabilita-card-header">
							📄 Dettagli Documento
							<b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right"
								@click="onClickSelezionaDatiDocumento()" :disabled="!!documentoJsonData.primaryKey">
								<i class="fas fa-pencil-alt"></i>
							</b-button>
						</div>
						<div class="sa-contabilita-card-grid">
							<span class="sa-contabilita-label">🔢 Num.: </span>
							<span class="sa-contabilita-data">{{ documentoJsonData.documentoNumero }}</span>

							<span class="sa-contabilita-label">📅 Data:</span>
							<span class="sa-contabilita-data">{{ formatDate(documentoJsonData.documentoData) }}</span>

							<span class="sa-contabilita-label">⚙️ Tipo:</span>
							<span class="sa-contabilita-data">{{ documentoJsonData.tipoDocumentoDescrizione }}</span>

							<span class="sa-contabilita-label">🚚 Causale:</span>
							<span class="sa-contabilita-data">{{ documentoJsonData.causaleDocumentoDescrizione }}</span>

							<span class="sa-contabilita-label">📦 Op. Mag.:</span>
							<span class="sa-contabilita-data fw-bold" :class="operazioneMagazzinoColor">{{
								operazioneMagazzino
							}}</span>

							<span class="sa-contabilita-label">📊 Op. Con.:</span>
							<span class="sa-contabilita-data" :class="operazioneContabileColor">{{ operazioneContabile
							}}</span>
						</div>
					</div>
				</div>

				<div class="ft-section-wrapper-item">
					<div class="sa-contabilita-info-card">
						<div class="sa-contabilita-card-header">
							🚚 Destinazione e Pagamento
							<b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right"
								:disabled="!causaleDocumento" @click="onClickCliente()">
								<i class="fas fa-pencil-alt"></i>
							</b-button>
						</div>
						<div class="sa-contabilita-card-grid">
							<span class="sa-contabilita-label">👤 Cliente:</span>
							<span class="sa-contabilita-data">{{ documentoJsonData.soggettoCognomeRagione }}</span>

							<span class="sa-contabilita-label">📍 Indir.:</span>
							<span class="sa-contabilita-data">
								<template
									v-if="documentoJsonData.soggettoIndirizzo && documentoJsonData.soggettoCap && documentoJsonData.soggettoProvincia">
									{{ documentoJsonData.soggettoIndirizzo }}, {{ documentoJsonData.soggettoCap }} ({{
										documentoJsonData.soggettoProvincia }})
								</template>
							</span>

							<span class="sa-contabilita-label">🧾 C.F./P. I.V.A.:</span>
							<span class="sa-contabilita-data">
								<template
									v-if="documentoJsonData.soggettoCodiceFiscale || documentoJsonData.soggettoPartitaIva">
									{{ documentoJsonData.soggettoCodiceFiscale }}/{{
										documentoJsonData.soggettoPartitaIva }}
								</template>
							</span>

							<span class="sa-contabilita-label">💳 Pagam.:</span>
							<span class="sa-contabilita-data text-success">{{
								documentoJsonData.metodoPagamentoDescrizione }}</span>

							<span class="sa-contabilita-label">👤 Dest.:</span>
							<span class="sa-contabilita-data">{{ documentoJsonData.destinazioneMerceDescrizione
							}}</span>
						</div>
					</div>
				</div>

			</div>
		</b-collapse>
		<contabilita-documento-dati-documento-modal-component ref="cmpContabilitaDocumentoDatiDocumentoModalComponent"
			@updateCausaleSelezionata="onUpdateCausaleSelezionata" @updateTipoDocumento="onUpdateTipoDocumento"
			@update="onUpdateJsonDataDatiDocumento" />
		<contabilita-documento-destinazione-modal-component ref="cmpContabilitaDocumentoClienteModalComponent"
			:operazioneMagazzino="documentoJsonData.causaleDocumentoOperazioneMagazzino"
			:soggettiCollegati="soggettiCollegati" @update="onUpdateJsonDataCliente" />
	</div>
</template>

<script>
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import moment from "moment";
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import ContabilitaDocumentoDatiDocumentoModalComponent from "./ContabilitaDocumentoDatiDocumentoModalComponent.vue";
import ContabilitaDocumentoDestinazioneModalComponent from "./ContabilitaDocumentoDestinazioneModalComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [StruttureMixin, ContabilitaMixin, UtilityMixin],
	components: { ContabilitaDocumentoDatiDocumentoModalComponent, ContabilitaDocumentoDestinazioneModalComponent },
	data() {
		return {
			righe: [],
			id: null,
			showCards: true,
			presidio: {},
			strutturaIbanOptions: [],
			strutturaIban: null,
			soggettiCollegati: "",
			causaleDocumento: null,
			tipoDocumento: null,
		};
	},
	mounted() {
		this.id = this.$route.params.id;
		this.contabilitaTipoDocumentoLoadData(this.presidio.codiceStruttura);
		this.contabilitaCausaliDocumentoLoadData(this.documentoJsonData.tipoDocumentoId);

		if (this.id != null && this.id != '-1') {
			this.showCards = false;
		}

	},
	computed: {


		isSezioneStrutturaMitteteComplete() {
			if (this.documentoJsonData.strutturaCodice == null || this.documentoJsonData.strutturaCodice.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.strutturaCap == null || this.documentoJsonData.strutturaCap.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.strutturaCodiceFiscale == null || this.documentoJsonData.strutturaCodiceFiscale.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.strutturaDenominazione == null || this.documentoJsonData.strutturaDenominazione.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.strutturaIndirizzo == null || this.documentoJsonData.strutturaIndirizzo.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.strutturaLocalitaCodiceIstat == null || this.documentoJsonData.strutturaLocalitaCodiceIstat.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.strutturaProvincia == null || this.documentoJsonData.strutturaProvincia.trim() == "") {
				return false;
			}
			return true;
		},
		isSezioneDettagliDocumentoComplete() {

			if (this.documentoJsonData.documentoData == null) {
				return false;
			}
			if (this.documentoJsonData.causaleDocumentoId == null || this.documentoJsonData.causaleDocumentoId.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.causaleDocumentoDescrizione == null || this.documentoJsonData.causaleDocumentoDescrizione.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.causaleCodice == null || this.documentoJsonData.causaleCodice.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.causaleDocumentoOperazioneContabile == null) {
				return false;
			}
			if (this.documentoJsonData.causaleDocumentoOperazioneMagazzino == null) {
				return false;
			}
			if (this.documentoJsonData.tipoDocumentoCodice == null || this.documentoJsonData.tipoDocumentoCodice.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.tipoDocumentoDescrizione == null || this.documentoJsonData.tipoDocumentoDescrizione.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.tipoDocumentoId == null || this.documentoJsonData.tipoDocumentoId.trim() == "") {
				return false;
			}

			return true;
		},
		isSezioneDestinazionePagamentoComplete() {

			if (this.documentoJsonData.soggettoCap == null || this.documentoJsonData.soggettoCap.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.soggettoCodiceFiscale == null || this.documentoJsonData.soggettoCodiceFiscale.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.soggettoCognomeRagione == null || this.documentoJsonData.soggettoCognomeRagione.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.soggettoIndirizzo == null || this.documentoJsonData.soggettoIndirizzo.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.soggettoProvincia == null || this.documentoJsonData.soggettoProvincia.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.soggettoLocalitaCodiceIstat == null || this.documentoJsonData.soggettoLocalitaCodiceIstat.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.destinazioneMerceCap == null || this.documentoJsonData.destinazioneMerceCap.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.destinazioneMerceDescrizione == null || this.documentoJsonData.destinazioneMerceDescrizione.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.destinazioneMerceIndirizzo == null || this.documentoJsonData.destinazioneMerceIndirizzo.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.destinazioneMerceLocalita == null || this.documentoJsonData.destinazioneMerceLocalita.trim() == "") {
				return false;
			}
			if (this.documentoJsonData.destinazioneMerceProvincia == null || this.documentoJsonData.destinazioneMerceProvincia.trim() == "") {
				return false;
			}
			return true;
		},

		operazioneMagazzinoColor() {
			switch (this.documentoJsonData.causaleDocumentoOperazioneMagazzino) {
				case -1:
					return "text-danger";
				case 1:
					return "text-success";
				default:
					return "text-primary";
			}
		},
		operazioneContabileColor() {
			switch (this.documentoJsonData.causaleDocumentoOperazioneContabile) {
				case -1:
					return "text-danger";
				case 1:
					return "text-success";
				default:
					return "text-primary";
			}
		},
		operazioneMagazzino() {
			switch (this.documentoJsonData.causaleDocumentoOperazioneMagazzino) {
				case -1:
					return "Scarico";
				case 1:
					return "Carico";
				case 0:
					return "Invariato";
				default:
					return "";
			}
		},
		operazioneContabile() {
			switch (this.documentoJsonData.causaleDocumentoOperazioneContabile) {
				case -1:
					return "Dare";
				case 1:
					return "Avere";
				case 0:
					return "Invariato";
				default:
					return "";
			}
		},
		isCompiled() {
			return this.isSezioneDestinazionePagamentoComplete && this.isSezioneDettagliDocumentoComplete && this.isSezioneStrutturaMitteteComplete; // this.jsonData.documentoNumero !== "" && this.jsonData.strutturaDenominazione !== "";
		},
	},
	watch: {
		isCompiled: function (params) {
			if (params) {
				this.$emit("isCompiled")
			}
		}
	},
	methods: {
		init(documentoJsonData) {
			this.documentoJsonData = documentoJsonData;
			if (documentoJsonData.id === "-1" || !documentoJsonData.id) {
				this.setDatiStruttura();
			}
		},
		getDescrizioneDestinazione() {
			return this.documentoJsonData.causaleDocumentoOperazioneMagazzino <= 0 ? "Destinazione" : "Fornitore";
		},
		formatDate(value) {
			if (value) {
				return moment(new Date(value)).format("DD-MM-YYYY");
			} else {
				return "---";
			}
		},
		onSelectCausaleSoggettiCollegati(soggettiCollegati) {
			this.soggettiCollegati = soggettiCollegati;
		},
		emitChange() {
			this.$emit("update", this.documentoJsonData);
		},
		getEmojiDocumentoStato(stato) {
			console.log(stato);
			switch (stato) {
				case "APERTO":
					return "🔓";
				case "CHIUSO":
					return "🔐";
				default:
					return "❗";
			}

		},

		getClassBadge(section, stato) {
			stato;
			switch (section) {
				case 'color':
					if (stato == 'APERTO') {
						return 'primary'
					}
					if (stato == 'CHIUSO') {
						return 'red'
					}
					return 'warning'
				case 'border':
					var returnValue = "1px solid ";
					if (stato == 'APERTO') {
						returnValue + ' primary'
					}
					if (stato == 'CHIUSO') {
						returnValue + ' red'
					} else {
						returnValue + ' warning'
					}
					return returnValue;
				default:
					break;
			}
		},
		onChangeIban() { },
		onShowSelezionaIban() {
			this.strutturaIban = this.documentoJsonData.strutturaIban;
		},
		onOkModificaIbanSelezionato() {
			this.documentoJsonData.strutturaIban = this.strutturaIban;
			this.$refs.mdlDatiStruttura.hide();
			this.emitChange();
		},
		onClickSelezionaIban() {
			this.$refs.mdlDatiStruttura.show();
		},
		onUpdateJsonDataDatiDocumento(data) {
			let confronto = this.confrontaDatiDettaglioDocumento(data, this.documentoJsonData);
			this.documentoJsonData = { ...this.documentoJsonData, ...data };
			this.emitChange();
			if (!confronto) {
				this.resetJsonDataDestinazioneRighe();
			} else {
				console.log("uguale");
			}
			if (this.isCompiled) {
				this.showCards = false;
			}
		},
		resetJsonDataDestinazioneRighe() {
			this.$emit("resetJsonDataDestinazioneRigheDocumento")

		},
		onUpdateJsonDataCliente(data) {
			console.log("update?!");

			this.documentoJsonData = { ...this.documentoJsonData, ...data };
			this.emitChange();
			if (this.isCompiled) {
				this.showCards = false;
			}
		},
		confrontaDatiDettaglioDocumento(nDati, oDati) {
			return nDati.causaleDocumentoId == oDati.causaleDocumentoId && nDati.causaleCodice == oDati.causaleCodice
				&& nDati.tipoDocumentoId == oDati.tipoDocumentoId && nDati.tipoDocumentoCodice == oDati.tipoDocumentoCodice

		},
		onClickSelezionaDatiDocumento() {
			let me = this;
			me.$refs.cmpContabilitaDocumentoDatiDocumentoModalComponent.init(me.documentoJsonData);
		},
		onClickCliente() {
			let me = this;
			me.$refs.cmpContabilitaDocumentoClienteModalComponent.init(me.documentoJsonData, me.causaleDocumento, me.tipoDocumento);
		},
		getInfoStrutturaIban() {
			let returnValue = "";
			let strutturaIban = this.strutturaIbanOptions.filter((e) => e.iban == this.documentoJsonData.strutturaIban);
			if (strutturaIban[0]) {
				returnValue = strutturaIban[0].banca;
			}

			return returnValue;
		},
		getIndirizzoSoggetto() {
			const indirizzo = this.documentoJsonData.soggettoIndirizzo || "";
			const cap = this.documentoJsonData.soggettoCap || "";
			const provincia = this.documentoJsonData.soggettoProvincia || "";
			const localita = this.documentoJsonData.soggettoLocalita || "";
			let returnValue = [];
			if (indirizzo) {
				returnValue.push(indirizzo);
			}
			if (cap) {
				returnValue.push(cap);
			}
			if (provincia) {
				returnValue.push(`(${provincia})`);
			}
			if (localita) {
				returnValue.push(localita);
			}
			return returnValue.join(", ");
		},
		onUpdateCausaleSelezionata(causaleSelezionata) {
			this.causaleDocumento = causaleSelezionata;
		},
		onUpdateTipoDocumento(tipoDocumentoSelezionata) {
			this.tipoDocumento = tipoDocumentoSelezionata;
		},
	},
};
</script>

<style scoped>
.ft-section-container {
	padding: 10px;
	display: flex;
	gap: 10px;
}

.ft-section-wrapper-item {
	flex: 1 1 auto !important;
	width: 100% !important;
	transition: transform 0.3s ease, box-shadow 0.3s ease;
	border: 1px solid transparent;
	border-radius: 15px;
}

.ft-section-wrapper-item:hover {
	transform: translateY(-10px);
	z-index: 10;
	position: relative;
	box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1), 0 0 15px rgba(0, 123, 255, 0.2);
}

.sa-contabilita-info-card {
	background: white;
	border-radius: 12px;
	border: none;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	border-left: 5px solid var(--bg-sidebar);
	height: 100% !important;
	overflow: hidden;
	position: relative;
}

/* .sa-contabilita-info-card::before {
	content: "";
	position: absolute;
	top: 0;
	left: 100px;
	width: 50%;
	height: 2px;
	background-color: forestgreen;
	border-radius: 3px 0 3px 0;
} */

.sa-contabilita-card-header {
	background: #f8f9fa;
	padding: 8px 12px;
	border-bottom: 1px solid #edf2f7;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 0.9rem;
	font-weight: 800;
	color: #4a5568;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

.sa-contabilita-card-grid {
	display: grid;
	grid-template-columns: auto 1fr;
	column-gap: 10px;
	row-gap: 5px;
	padding: 12px;
	font-size: 1rem;
	align-items: center;
}

.sa-contabilita-label {
	color: #2d3748;
	font-weight: 700;
	font-size: 1rem;
	display: flex;
	align-items: center;
	gap: 5px;
}

.sa-contabilita-data {
	color: #718096;
	font-weight: 600;
}

.sa-contabilita-data-full {
	grid-column: span 2;
	padding-top: 4px;
	border-top: 1px solid #f7fafc;
}

.sa-ft-badge-v2 {
	font-size: 10px;
	background: #f1f5f9;
	border: 1px solid var(--bg-sidebar);
	padding: 2px 6px;
	border-radius: 4px;
	width: fit-content;
	color: var(--bg-sidebar)
}

/* .sa-card {
	border-radius: 14px !important;
	border: 1px solid rgba(0, 0, 0, 0.06);
	border-left: 4px solid var(--bg-sidebar) !important;
	background-color: #ffffff !important;
	height: 100%;
	padding: 12px !important;
	margin-bottom: 12px !important;
	box-shadow: 0 8px 18px rgba(0, 0, 0, 0.06), 0 4px 6px rgba(0, 0, 0, 0.04) !important;
	transition: transform 0.3s ease, box-shadow 0.3s ease !important;
}

.sa-card-warning {
	border-left: 4px solid #ffffff !important;
}

.sa-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 10px 28px rgba(0, 0, 0, 0.1), 0 4px 10px rgba(0, 0, 0, 0.06);
}

.card-header {
	border-radius: 9px !important;
	border-left: 2px solid var(--bg-sidebar) !important;
	border-top: 1px solid var(--bg-main-nav-bar) !important;
	border-bottom: 1px solid var(--bg-main-nav-bar) !important;
	border-right: 1px solid var(--bg-main-nav-bar) !important;
	padding: 7px !important;
	margin-bottom: 5px !important;
} */
</style>
